import React from 'react';
import {injectIntl} from "react-intl";

function SpecialismAutoSuggestField() {
  return '';
}

export default injectIntl(SpecialismAutoSuggestField);
